import Vue from 'vue'
import VueRouter from 'vue-router'
import Top from '@/components/Top'
import AdminCreate from '@/components/AdminCreate'
import PartUserCreate from '@/components/PartUserCreate'
import ForgotPassReset from '@/components/ForgotPassReset'
import MfaKeyCreate from '@/components/MfaKeyCreate'
import Login from '@/components/Login'
import License from '@/components/License';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/Top',
    name: 'Top',
    component: Top
  },
  {
    path: '/AdminCreate',
    name: 'AdminCreate',
    component: AdminCreate
  },
  {
    path: '/PartUserCreate',
    name: 'PartUserCreate',
    component: PartUserCreate
  },
  {
    path: '/ForgotPassReset',
    name: 'ForgotPassReset',
    component: ForgotPassReset
  },
  {
    path: '/MfaKeyCreate',
    name: 'MfaKeyCreate',
    component: MfaKeyCreate
  },
  {
    path: '/License',
    name: '/License',
    component: License
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
